import { Box, Divider, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface CostTooltipMessageProps {
  currency: string
  fixedCosts: number
  hoursPerCostRate: number
  spendingCostsApprovedAmountCents: number
  title: string
}

const CostTooltipMessage = ({
  currency,
  fixedCosts,
  hoursPerCostRate,
  spendingCostsApprovedAmountCents,
  title,
}: CostTooltipMessageProps) => {
  const {
    access: { locale },
  } = useCurrentSession()

  return (
    <>
      <Box alignItems="flexStart">
        <Text size="200" color="grey000White" weight="semibold">
          {title.toUpperCase()}
        </Text>
      </Box>

      <Box flexDirection="row" justifyContent="spaceBetween" paddingY="s16">
        <Text size="300" color="grey000White" weight="medium">
          {i18n.t(
            'project_management.overview.sections.financial_details.insights.cost_to_date.tooltip_message.hours'
          )}
        </Text>
        <Text size="300" color="grey000White" weight="medium">
          {MoneyWithCurrency({ amount: Math.round(hoursPerCostRate), currency, locale })}
        </Text>
      </Box>
      <Divider backgroundColor="#FFFFFF" />
      <Box paddingY="s16" gap="s4">
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="300" color="grey000White" weight="medium">
            {i18n.t(
              'project_management.overview.sections.financial_details.insights.cost_to_date.tooltip_message.validated_spendings'
            )}
          </Text>
          <Text size="300" color="grey000White" weight="medium">
            {MoneyWithCurrency({ amount: spendingCostsApprovedAmountCents, currency, locale })}
          </Text>
        </Box>
      </Box>
      <Divider backgroundColor="#FFFFFF" />
      <Box flexDirection="row" justifyContent="spaceBetween" paddingTop="s16">
        <Text size="300" color="grey000White" weight="medium">
          {i18n.t(
            'project_management.overview.sections.financial_details.insights.cost_to_date.tooltip_message.fixed_costs'
          )}
        </Text>
        <Text size="300" color="grey000White" weight="medium">
          {MoneyWithCurrency({ amount: fixedCosts, currency, locale })}
        </Text>
      </Box>
    </>
  )
}

export default CostTooltipMessage
